import React from "react";
import { formatMoney } from "@/lib/money";

// You may want to import your currencies and categories if available in context
// import { currencies } from "@/lib/types";

export default function DefaultModal({
  open,
  onClose,
  item,
  category,
  categories = [],
}: {
  open: boolean;
  onClose: () => void;
  item?: any;
  category?: any;
  categories?: any[];
}) {
  if (!open || !item) return null;
  const promo = item.promotion || category?.promotion;

  return (
    <div
      style={{
        position: "fixed",
        zIndex: 1000,
        left: 0,
        top: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0,0,0,0.4)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 16,
          minWidth: 320,
          maxWidth: 420,
          padding: 32,
          boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
          position: "relative"
        }}
        onClick={e => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: 16,
            right: 16,
            background: "none",
            border: "none",
            fontSize: 24,
            cursor: "pointer"
          }}
          aria-label="Close"
        >
          ×
        </button>
        <h2 style={{ margin: 0, marginBottom: 8 }}>{item.title || item.name}</h2>
        {/* Promotion Badge */}
        {promo && (
          <div style={{
            marginBottom: 12,
            padding: "4px 12px",
            borderRadius: 8,
            background: "#ffe5e5",
            color: "#b00",
            fontWeight: 700,
            display: "inline-block"
          }}>
            {promo.custom_label || promo.title || promo.discount_type}
            {promo.discount_type === "percentage" && (
              <>: -{promo.discount_value}%</>
            )}
            {promo.discount_type === "fixed" && (
              // Was "-{value}{item.currency}" — code glued to the amount, and
              // unrounded. Now goes through the one money formatter.
              <>: -{formatMoney(Number(promo.discount_value), item.currency)}</>
            )}
            {promo.discount_type === "bogo" && (
              <>: Buy 1 Get 1</>
            )}
            {promo.discount_type === "custom" && promo.description && (
              <>: {promo.description}</>
            )}
          </div>
        )}
        {/* Image */}
        {item.image && (
          <img
            src={item.image}
            alt={item.title || item.name}
            style={{
              width: "100%",
              borderRadius: 12,
              marginBottom: 12,
              objectFit: "cover"
            }}
          />
        )}
        {/* Description */}
        <div style={{ marginBottom: 12, color: "#444" }}>
          {item.description}
        </div>
        {/* Price & Availability */}
        <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 8 }}>
          {item.price !== undefined && (
            <span style={{ fontWeight: 600, fontSize: 18 }}>
              Price: {item.currency}{item.price}
            </span>
          )}
          {typeof item.available === "boolean" && (
            <span
              style={{
                padding: "2px 8px",
                borderRadius: 6,
                fontSize: 13,
                background: item.available ? "#e6fbe6" : "#fdeaea",
                color: item.available ? "#1a7f37" : "#b00",
                fontWeight: 500
              }}
            >
              {item.available ? "Available" : "Unavailable"}
            </span>
          )}
        </div>
        {/* Category */}
        <div style={{ fontSize: 13, color: "#888", marginBottom: 8 }}>
          <span style={{ fontWeight: 600 }}>Category:</span>{" "}
          {item.category_id
            ? (categories.find((c: any) => c.id === item.category_id)?.name || category?.name || ",")
            : category?.name || ","}
        </div>
        {/* Variants */}
        {item.variants && (
          <div style={{ fontSize: 13, marginBottom: 8 }}>
            <span style={{ fontWeight: 600 }}>Variants:</span>{" "}
            {Array.isArray(item.variants)
              ? item.variants.join(", ")
              : typeof item.variants === "object" && item.variants !== null
                ? Object.entries(item.variants).map(([key, value]) => (
                    <span key={key} style={{ marginRight: 8 }}>
                      <span style={{ fontWeight: 600 }}>{key}:</span> {String(value)}
                    </span>
                  ))
                : String(item.variants)}
          </div>
        )}
        {/* Nutritional Info */}
        {item.nutritional_info && (
          <div style={{ fontSize: 13, marginBottom: 8 }}>
            <span style={{ fontWeight: 600 }}>Nutritional Info:</span>{" "}
            {typeof item.nutritional_info === "object" && item.nutritional_info !== null
              ? Object.entries(item.nutritional_info).map(([key, value]) => (
                  <span key={key} style={{ marginRight: 8 }}>
                    <span style={{ fontWeight: 600 }}>{key}:</span> {String(value)}
                  </span>
                ))
              : String(item.nutritional_info)}
          </div>
        )}
        {/* Tags */}
        {item.tags && item.tags.length > 0 && (
          <div style={{ display: "flex", flexWrap: "wrap", gap: 4, fontSize: 13, marginBottom: 8 }}>
            <span style={{ fontWeight: 600 }}>Tags:</span>
            {item.tags.map((tag: string) => (
              <span key={tag} style={{
                padding: "2px 8px",
                borderRadius: 6,
                background: "#f3f3f3",
                marginLeft: 4
              }}>{tag}</span>
            ))}
          </div>
        )}
        {/* Created At */}
        {item.created_at && (
          <div style={{ fontSize: 12, color: "#aaa", marginTop: 8 }}>
            <span style={{ fontWeight: 600 }}>Created:</span> {new Date(item.created_at).toLocaleString()}
          </div>
        )}
      </div>
    </div>
  );
}